import { useReducer, useEffect } from "react";
import DataGrid, {
  Column,
  Paging,
  Pager,
  Lookup,
  RequiredRule,
} from "devextreme-react/data-grid";
import * as actions from "../../actions/settings";
import settingsReducer from "../../reducers/settings";
import { CONFIG } from "../settings/config";

const initialState = {
  LanguageData: null,
  TimezoneData: [],
};
export default () => {
  const [state, dispatch] = useReducer(settingsReducer, initialState);
  let { LanguageData, TimezoneData } = state;

  useEffect(() => {
    actions.fetchLanguage(dispatch);
    actions.fetchTimezoneInfo(dispatch);
  }, []);

  function getUniqueRegions() {
    if (TimezoneData && TimezoneData.length) {
      return [
        ...new Set(
          TimezoneData.map((e) => {
            return e.region;
          })
        ),
      ].map((val) => {
        return {
          region: `${val}`,
        };
      });
    } else return [];
  }

  function setStateValue(rowData, value) {
    this.defaultSetCellValue(rowData, value);
  }

  const onRowInserted = (data) => {
    const { language, region } = data.data;
    const LangModel = [
      {
        languageID: 0,
        languageRegionID: 0,
        language: language,
        isActive: true,
        region: region,
      },
    ];
    actions.manageLanguageData(dispatch, { LangModel: LangModel });
  };

  const onRowUpdated = (data) => {
    const { languageID, language, isActive, region,languageRegionID } = data.data;
    const LangModel = [
      {
        languageID: languageID,
        languageRegionID: languageRegionID,
        language: language,
        isActive: true,
        region: region,
      },
    ];
    actions.manageLanguageData(dispatch, { LangModel: LangModel });
  };

  const onRowRemoved = (data) => {
    const { languageID, language, isActive, region,languageRegionID } = data.data;
    const LangModel = [
      {
        languageID: languageID,
        languageRegionID: languageRegionID,
        language: language,
        isActive: false,
        region: region,
      },
    ];
    actions.manageLanguageData(dispatch, { LangModel: LangModel });
  };

  const checkDuplicateExists = (data, newRow, keysToCheck) => {
    return data.some((entry) =>
      keysToCheck.every((key) => entry[key].toLowerCase() === newRow[key].toLowerCase() )
    );
  };

  const onRowValidating = (e) => {
    const updatedRow = { ...e.oldData, ...e.newData };

    if (
      checkDuplicateExists(LanguageData, updatedRow, ["language", "region"])
    ) {
      e.errorText = "Language and Region combination should not be duplicate. Please click UNDO";
      e.isValid = false;
    }
  };

  const handlers = {
    onRowInserted: onRowInserted,
    onRowUpdated: onRowUpdated,
    onRowRemoved: onRowRemoved,
    onRowValidating: onRowValidating,
  };

  return (
    <>
      <DataGrid
        dataSource={LanguageData}
        allowColumnReordering={true}
        showBorders={true}
        {...CONFIG.LANGUAGE}
        {...handlers}
      >
        <Paging defaultPageSize={10} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          showInfo={true}
          showNavigationButtons={true}
        />
        <Column
          dataField="languageID"
          caption="Id"
          dataType="number"
          visible={false}
          allowEditing={false}
        ></Column>

         <Column
          dataField="languageRegionID"
          caption="Id"
          dataType="number"
          visible={false}
          allowEditing={false}
        ></Column>

        <Column
          dataField="region"
          caption="Region"
          dataType="string"
          setCellValue={setStateValue}
        >
          <Lookup
            dataSource={getUniqueRegions}
            valueExpr="region"
            displayExpr="region"
          />
          <RequiredRule />
        </Column>

        <Column
          dataField="language"
          caption="Language"
          visible={true}
          allowEditing={true}
        >
          <RequiredRule />
        </Column>

        <Column
          dataField="isActive"
          caption="isActive"
          visible={false}
        ></Column>
      </DataGrid>
    </>
  );
};
